/*globals $ */

import VideoPlayer from './VideoPlayer';

class Quiz {
  constructor($container, sceneManager) {
    this.sceneManager     = sceneManager;
    this.$container       = $container;
    this.questionData     = undefined;

    if(this.$container.attr('data-id') != undefined) {
      this.questionId = this.$container.attr('data-id');

      for(let i = 0; i < window.data_kai.length; i++) {
        if(this.questionId == window.data_kai[i]['id']) {
          this.questionData = window.data_kai[i];
          break;
        }
      }
    }


    this.question       = new Question(this.$container.find('.QuizStep--question'));
    this.answer         = new Answer(this.sceneManager, this.$container.find('.QuizStep--answer'), this.questionData);

    this.$btnExecute    = this.$container.find('.Btn--execute-answer');
    this.$btnNextStep   = this.$container.find('.Btn--next-step');

    this.$btnExecute.on('click', () => {
      this.question.fadeout();
      this.answer.fadein(this.question.getSelectValue());
    });

    this.$btnNextStep.on('click', () => {
      this.answer.resultMovie.pause();
      this.sceneManager.nextStep();
    });
  }

  reset() {
    this.question.reset();
    this.answer.reset();
  }
}

class Question {
  constructor($container) {
    this.$container = $container;
    this.hasMultiVideo = false;

    if(this.$container.find('.Question__movie--multiple').length) {
      this.hasMultiVideo = true;
    }

    if(this.$container.find('.RadioBtnList--checkbox').length) {
      this.$container.find('.radio-answer').change(() => {
        let valSet = [];
        this.$container.find('.radio-answer:checked').each((i, e) => {
          valSet.push(parseInt($(e).val()));
        });
        if(valSet.length == 2) {
          this.$container.find('.RadioBtnList').addClass('RadioBtnList--checked');
          this.$container.find('.RadioBtnList').next('.Choices__execute').find('.Btn').removeClass('Btn--disable');
        } else {
          this.$container.find('.RadioBtnList').removeClass('RadioBtnList--checked');
          this.$container.find('.RadioBtnList').next('.Choices__execute').find('.Btn').addClass('Btn--disable');
        }
      });
    } else if(this.$container.find('.RadioBtnList').length) {
      this.$container.find('.RadioBtnList').on('click', (e) => {
        $(e.currentTarget).addClass('RadioBtnList--checked');
        $(e.currentTarget).next('.Choices__execute').find('.Btn').removeClass('Btn--disable');
      });
    }

    this.movies = [];
    this.$container.find('.MovieWrap').each((i, e) => {
      this.movies.push(new VideoPlayer($(e)));
    });

    this.$container.find('.js-play-movie').on('click', (e) => {
      let target = parseInt($(e.currentTarget).attr('data-target-movie'));
      for(let i = 0; i < this.movies.length; i++) {
        if(i == target) {
          this.movies[i].$el.removeClass('MovieWrap--disabled');
          setTimeout(() => {
            this.movies[target].play();
          }, 50);
        } else {
          this.movies[i].pause();
          this.movies[i].$el.addClass('MovieWrap--disabled');
        }
      }
    });

    this.hasQuestionData = false;
    if(this.$container.find('.radio-answer').length) {
      this.hasQuestionData = true;
    }
  }
  getSelectValue() {
    if(this.hasQuestionData) {
      if(this.$container.find('.RadioBtnList--checkbox').length) {
        let valSet = [];
        this.$container.find('.radio-answer:checked').each((i, e) => {
          valSet.push(parseInt($(e).val()));
        });
        return valSet;
      } else {
        return [parseInt(this.$container.find('.radio-answer:checked').val())];
      }

    } else {
      return [];
    }
  }
  fadeout() {
    this.$container.css('display', 'none');
    for(let i = 0; i < this.movies.length; i++) {
      this.movies[i].pause();
      if(this.hasMultiVideo) this.movies[i].$el.addClass('MovieWrap--disabled');
    }
  }
  reset() {
    this.$container.find('.RadioBtnList').removeClass('RadioBtnList--checked');
    this.$container.css('display', 'block');
    for(let i = 0; i < this.movies.length; i++) {
      this.movies[i].pause();
      if(this.hasMultiVideo) this.movies[i].$el.addClass('MovieWrap--disabled');
    }

    this.$container.find('.radio-answer:checked').each((i, e) => {
      $(e).prop('checked', false);
    });
    this.$container.find('.Choices__execute').find('.Btn').addClass('Btn--disable');
  }
}

class Answer {
  constructor(sceneManager, $container, questionData = undefined) {
    this.sceneManager   = sceneManager;
    this.$container     = $container;
    this.questionData   = questionData;
    this.resultMovie    = new VideoPlayer(this.$container.find('.ResultMovie'));
  }

  fadein(selectedValue) {
    // console.log('選択した回答', selectedValue);
    if(this.questionData != undefined && selectedValue.length > 0) {
      // console.log('正解のデータ', this.questionData['correct']);

      if( ( selectedValue.length === this.questionData['correct'].length ) && this.questionData['correct'].every( item => selectedValue.includes( item ) ) ) {
        this.$container.addClass('answer-correct');
        this.$container.removeClass('answer-incorrect');
        this.sceneManager.correctCount++;

      } else {

        this.$container.removeClass('answer-correct');
        this.$container.addClass('answer-incorrect');
      }
    } else {

      if(Math.floor(Math.random() * 2) > 1) {
        this.$container.addClass('answer-correct');
        this.$container.removeClass('answer-incorrect');
      } else {
        this.$container.removeClass('answer-correct');
        this.$container.addClass('answer-incorrect');
      }
    }

    this.$container.css('display', 'block');

    setTimeout(() => {
      window.scrollTo(0, 0);
      this.$container.parent().addClass('Quiz--answer');
      setTimeout(() => {
        this.resultMovie.play();
      }, 100);

    }, 40);
  }
  reset() {
    this.$container.css('display', 'none');
    this.$container.parent().removeClass('Quiz--answer');
    this.$container.removeClass('answer-correct');
    this.$container.removeClass('answer-incorrect');
    this.resultMovie.pause();
  }
}



export default Quiz;
